export class BaseDTO {
    
    id: string;
    
    tenantId: string;
    
    createdBy: string;
    
    updatedBy: string;
    
    createdAt: Date;
    
    updatedAt: Date;
    
}
